// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","AdSlotBranding__desktopWrap":"bhh_a","AdSlotBranding__desktop":"bhh_b","AdSlotBranding__mobile":"bhh_c"};